import androidx.compose.runtime.*
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import org.jetbrains.compose.web.renderComposable

fun main() {
    renderComposable(rootElementId = "root") {
        HeaderSection()
        AboutSection()
        SkillsSection()
        ProjectsSection()
        ContactSection()
    }
}
